import moment from 'moment';
import React from 'react';
import { TableInput, TextAreaInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { useQuery } from '../../../../../hooks/UseQuery';
import SimpleSelect from '../../../../../components/common/SimpleSelect';

export const TableRowComponent = React.memo(
  ({ key, item, index, allmonth, updateModuleData }: any) => {
    const isView = useQuery('isView') === 'true' ? true : false;
    const rowId = item?._id || item?._tempId;

    const handleInputChange = (
      fieldName: string,
      value: string | number | null,
    ) => {
      updateModuleData('row', index, fieldName, { [fieldName]: value });
    };

    return (
      <React.Fragment key={key}>
        <tr>
          <td>{index + 1}</td>
          <th>
            {item.type}
            {/* <SimpleSelect
              name={`type`}
              value={item.type}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleInputChange(e.target.name, e.target.value);
              }}
              options={[
                { value: 'Play in', label: 'Play in' },
                { value: 'Lubrication', label: 'Lubrication' },
                { value: 'All Bushes Play', label: 'All Bushes Play' },
                { value: 'Bore Checking Of', label: 'Bore Checking Of' },
                { value: 'Gear Profile Of', label: 'Gear Profile Of' },
                { value: 'Langota', label: 'Langota' },
                { value: 'Alignment of', label: 'Alignment of' },
              ]}
              style={{
                padding: '8px',
                fontSize: '1.2rem',
                border: '3px solid white',
                borderRadius: '50%',
                cursor: 'pointer',
                outline: 'none',
                width: '70px',
                backgroundColor: 'white',
                color: 'black',
              }}
              optionStyle={{
                backgroundColor: 'white',
                color: 'black',
                width: '40px',
              }}
            /> */}
          </th>
          <td>
            <TextAreaInput
              isView={true}
              style={{ height: '80px', minWidth: '180px' }}
              name="checkpoint"
              // type="text"
              value={item.checkpoint}
              onChange={(e: any) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <TableInput
              isView={true}
              style={{ height: '80px' }}
              name="method"
              type="text"
              value={item.method}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <TableInput
              isView={true}
              style={{ height: '80px' }}
              name="ctx"
              type="text"
              value={item.ctx}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <TableInput
              isView={true}
              style={{ height: '80px' }}
              name="description"
              type="text"
              value={item.description}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <SimpleSelect
              name={`result`}
              value={item.result}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleInputChange(e.target.name, e.target.value);
              }}
              options={[
                { value: '', label: 'none' },
                { value: 'true', label: '✓' },
                { value: 'false', label: '⨯' },
                { value: 'other', label: 'other' },
              ]}
              style={{
                padding: '8px',
                fontSize: '1.2rem',
                border: '3px solid white',
                borderRadius: '50%',
                cursor: 'pointer',
                outline: 'none',
                width: '70px',
                backgroundColor: 'white',
                color: 'black',
              }}
              optionStyle={{
                backgroundColor: 'white',
                color: 'black',
                width: '40px',
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              style={{ height: '80px' }}
              name="action_taken"
              type="text"
              value={item.action_taken}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td style={{ minWidth: '150px', width: '150px' }}>
            <TextAreaInput
              isView={isView}
              style={{ height: '80px' }}
              name="remark"
              //   type="text"
              value={item.remark}
              onChange={(e: any) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
        </tr>
      </React.Fragment>
    );
  },
  (prevProps, nextProps) => {
    // Check if the relevant data for this row has changed
    return (
      prevProps.item === nextProps.item && prevProps.index === nextProps.index
    );
  },
);
